<template>
  <main class="min-h-screen bg-gray-300">
    <section class="flex flex-col justify-center min-h-screen">
      <div class="max-w-xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow rounded-lg">
          <div class="border-b border-gray-200 px-4 py-5 sm:px-6 font-medium">
            {{ $t('password_lost_title') }}
          </div>
          <div class="px-4 py-5 sm:p-6" v-if="!success">
            <p class="mb-3">{{ $t('password_lost_subtitle') }}</p>
            <sqr-input-email
              :label="$t('password_lost_email')"
              name="email"
              :value="email"
              @change="fieldSet({ name: 'email', value: $event })"
              size="large"
            />
            <sqr-error-text :error="error" class="mt-3" />
          </div>
          <div class="px-4 py-5 sm:p-6 bg-green-50" v-if="success">
            <div class="flex items-center space-x-4">
              <CheckCircleIcon class="h-16 w-16 text-green-500" />
              <span>{{ $t('password_lost_success') }}</span>
            </div>
          </div>
          <div
            class="border-t border-gray-200 px-4 py-4 sm:px-6 flex space-x-2 justify-end"
          >
            <sqr-button
              :label="$t('buttons_cancel')"
              color="transparent"
              @click="$router.back()"
            />
            <sqr-button
              v-if="!success"
              :label="$t('password_lost_confirm')"
              color="green"
              @click="requestAndGo()"
              :loading="loading"
            />
            <router-link :to="{ name: 'sign-in' }">
              <sqr-button
                v-if="success"
                :label="$t('password_sign_in')"
                color="green"
              />
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { CheckCircleIcon } from '@vue-hero-icons/outline';

import { mapGetters, mapMutations } from 'vuex';

import SqrInputEmail from '@/components/SqrInputEmail';
import SqrButton from '@/components/SqrButton';
import SqrErrorText from '@/components/SqrErrorText';

export default {
  name: 'PasswordLost',
  components: {
    SqrInputEmail,
    SqrButton,
    SqrErrorText,
    CheckCircleIcon
  },
  computed: {
    ...mapGetters('auth', ['email', 'errors'])
  },
  data() {
    return {
      loading: false,
      error: null,
      success: false
    };
  },
  methods: {
    ...mapMutations('auth', ['fieldSet']),
    async requestAndGo() {
      try {
        this.loading = true;
        this.error = null;
        const email = this.email;
        await this.$fb()
          .auth()
          .sendPasswordResetEmail(email);
        this.success = true;
        this.loading = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
